import React from "react"

import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import { useTranslation } from "react-i18next"

const category = (category) => {
  let p = category.split(",")
  if (p && p.length > 0) {
    return p[0]
  } else {
    return category
  }
}

const NewsCard = ({ item }) => {
  const { t } = useTranslation()
  return (
    <article className="block h-full overflow-hidden rounded-xl isolate">
      <Link
        className="relative block h-full transition-all duration-300 bg-gray-100 group hover:bg-primary-600"
        link={item.link}
      >
        <span className="absolute top-0 left-0 z-50 block w-full h-3 transition-opacity duration-300 opacity-0 bg-secondary-hover group-hover:opacity-100"></span>
        <div className="flex flex-col justify-between h-full">
          <div>
            {item.image && item.image.filename && (
              <div className="relative">
                <Image
                  className="absolute inset-0 object-cover w-full h-full transition-all duration-300 group-hover:opacity-0"
                  image={item.image}
                  aspectRatio="1by1"
                />
              </div>
            )}
            <div className="py-2 transition-all duration-300 px-grid group-hover:pt-4 group-hover:-mt-full">
              <span className="inline-block mb-1 mr-4 text-sm font-semibold text-gray-500 transition-colors duration-300 kicker kicker-h5 group-hover:text-white">
                {item.date}
              </span>
              <span className="inline-block mb-1 text-sm font-semibold text-secondary kicker kicker-h5 ">
                {t(`categories.${category(item.category)}`)}
              </span>
              <Headline
                headline={item.headline}
                tagName="span"
                headlineLevel="h5"
                className="font-semibold transition-colors duration-300 line-clamp-3 group-hover:text-white group-hover:line-clamp-none"
              />
              {item.text?.length > 0 && (
                <div className="w-full h-0 overflow-hidden transition-all duration-300 group-hover:h-32">
                  <div className="transition-all duration-300 transform translate-y-full group-hover:translate-y-0">
                    <div className="h-32">
                      <p className="mt-2 prose transition-colors duration-300 line-clamp-4 group-hover:text-white">
                        {item.text}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {item.link_text?.length > 0 && (
            <span className="inline-block px-4 pb-2 font-semibold transition-all text-primary group-hover:text-white">
              {item.link_text}
            </span>
          )}
        </div>
      </Link>
    </article>
  )
}

export default NewsCard
